/**
 * actions/locales.ts
 * desc: application locale actions
 * note: implementation is based on the formatjs lib
 */

import { loadDictionaries, type CompiledMessages } from '../../utilities/localization';
import constants from '../../settings/constants';
import type { AppThunk } from '../index';

export interface UpdateLocaleSuccessPayload {
    locale: string;
    dictionaries: CompiledMessages;
}

export interface UpdateLocaleErrorPayload {
    locale: string;
    messages: CompiledMessages;
}



//*************************************************
//*****   UPDATE Locale (Instance)   **************
//*************************************************
export function updateLocale(newLocale: string): AppThunk<Promise<CompiledMessages>> {
    return async (dispatch) => {

        dispatch(_updateLocaleRequest());

        try {
            const { locale, messages } = await loadDictionaries(newLocale);
            dispatch(_updateLocaleSuccess({ locale, dictionaries: messages }));
            return messages;
        } catch (err) {
            dispatch(_updateLocaleError({ locale: window.Ym?.DEFAULT_LOCALE || constants.LOCALES.DEFAULT, messages: {} }));
            // @ts-expect-error Error() coerces any value itself; String(err) would
            // change the message for `undefined` ('' vs 'undefined') and Symbols
            throw new Error(err);
        }
    };
}

function _updateLocaleError(payload: UpdateLocaleErrorPayload) {
    return {
        type: 'UPDATE_LOCALE_ERROR',
        payload,
    } as const;
}

function _updateLocaleRequest() {
    return {
        type: 'UPDATE_LOCALE_REQUEST',
    } as const;
}

function _updateLocaleSuccess(payload: UpdateLocaleSuccessPayload) {
    return {
        type: 'UPDATE_LOCALE_SUCCESS',
        payload,
    } as const;
}

export type LocalesAction =
    | ReturnType<typeof _updateLocaleError>
    | ReturnType<typeof _updateLocaleRequest>
    | ReturnType<typeof _updateLocaleSuccess>;
